// Device fingerprint helper.
//
// FingerprintJS OSS produces a stable-ish "visitor ID" hashed from ~30
// browser attributes (canvas, WebGL, screen, timezone, hardware, fonts…).
// It's not perfect — a determined user can switch browsers or hardware —
// but it survives incognito mode, VPN switching, and cookie clears, which
// covers the common signup-farming case we're guarding against.
//
// The agent init is expensive (~200ms first time), so we memoize the
// promise for the tab's lifetime.
import FingerprintJS from '@fingerprintjs/fingerprintjs';

let agentPromise = null;
let cachedId = null;

/**
 * Return the FingerprintJS visitor ID for this browser.
 * Returns an empty string if fingerprinting fails (never throws).
 */
export async function getDeviceFingerprint() {
  if (cachedId) return cachedId;
  try {
    if (!agentPromise) agentPromise = FingerprintJS.load();
    const agent = await agentPromise;
    const result = await agent.get();
    cachedId = result.visitorId || '';
    return cachedId;
  } catch (err) {
    // Never break sign-in because fingerprinting failed. Just return empty
    // and the backend will fall back to IP-only enforcement.
    // eslint-disable-next-line no-console
    console.warn('Fingerprint capture failed', err);
    return '';
  }
}
